<template>
<div class="chapter">
<div class="inner_page">
<p class="p10">This book is for Robert Ivey, my father, who showed me there wasn’t anything I couldn’t do. His love for reading had no boundaries, and he made sure that I had none. Thank you for everything you’ve done for me and the pride you had in my writing by reading my first two books.</p>
<p class="p11">I just wish you could read this one too.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?5971c6ca